import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import store from "./store";
import router from "./router";
import VueTheMask from "vue-the-mask";
import HighchartsVue from "highcharts-vue";

Vue.use(HighchartsVue);
Vue.use(VueTheMask);
Vue.config.productionTip = false;

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
